<div class="service-widget">
  <div class="widget-header">
    <div class="widget-title">
      <kendo-svg-icon
        [icon]="serviceIcon()"
        class="service-icon"
      ></kendo-svg-icon>
      <div class="title-content">
        <h5 class="service-name">{{ service().serviceName }}</h5>
        <p class="service-description">{{ serviceSubtitle() }}</p>
      </div>
    </div>
    <div class="widget-actions">
      <button
        kendoButton
        themeColor="primary"
        [svgIcon]="editIcon"
        size="small"
        (click)="handleModify()"
        class="action-button"
      >
        Modify
      </button>
      <button
        kendoButton
        themeColor="error"
        [svgIcon]="trashIcon"
        size="small"
        (click)="handleCancel()"
        class="action-button"
      >
        Cancel
      </button>
    </div>
  </div>

  <div class="widget-body">
    <div class="service-details">
      @for (detail of getServiceDetails(); track detail.label) {
        <div class="detail-item">
          <div class="detail-label">{{ detail.label }}</div>
          <div class="detail-value">
            @if (detail.type === 'badge') {
              <span
                class="badge"
                [class]="detail.badgeClass"
              >
                {{ detail.value }}
              </span>
            } @else if (detail.type === 'date') {
              {{ detail.value | date: 'shortDate' }}
            } @else if (detail.type === 'currency') {
              {{ detail.value | currency: 'USD' : 'symbol' : '1.2-2' }}
            } @else if (detail.type === 'number') {
              {{ detail.value | number }}
            } @else {
              {{ detail.value }}
            }
          </div>
        </div>
      }
    </div>

    <div class="service-description-full">
      <p class="description-text">{{ service().description }}</p>
    </div>
  </div>
</div>

<!-- Cancel Service Confirmation Dialog -->
@if (isCancelDialogOpen()) {
  <kendo-dialog
    title="Cancel Service"
    (close)="closeCancelDialog()"
    [minWidth]="400"
    [width]="500"
  >
    <div>
      <p>
        Are you sure you want to cancel
        <strong>{{ service().serviceName }}</strong>
        ?
      </p>
      <p>This action cannot be undone.</p>

      <form
        [formGroup]="cancelForm"
        class="cancel-form"
      >
        <kendo-formfield>
          <kendo-label
            labelCssClass="k-form-label"
            text="Reason for Cancellation (optional)"
          ></kendo-label>
          <kendo-textarea
            formControlName="reason"
            placeholder="Please provide a reason for cancelling this service"
            class="w-100"
          ></kendo-textarea>
        </kendo-formfield>
      </form>
    </div>

    <kendo-dialog-actions>
      <button
        kendoButton
        (click)="closeCancelDialog()"
        themeColor="secondary"
      >
        Close
      </button>
      <button
        kendoButton
        (click)="confirmCancel()"
        themeColor="error"
        [disabled]="cancelForm.invalid"
      >
        Confirm Cancellation
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
